import { OCR_API_BASE, postOcrImage } from "./paddleTextClient";

const TABLE_TIMEOUT_MS = 15 * 60 * 1000;

/**
 * @param {Blob} imageBlob
 * @returns {Promise<{ success: boolean, tables: Array, textRegions: Array, error?: string }>}
 */
export async function extractTableStructure(imageBlob) {
  let response;
  try {
    response = await postOcrImage(imageBlob, "/ocr/extract-table", TABLE_TIMEOUT_MS);
  } catch (err) {
    throw new Error(
      `Could not reach OCR service at ${OCR_API_BASE} (${
        err instanceof Error ? err.message : String(err)
      })`,
    );
  }

  if (!response.ok) {
    const body = await response.text().catch(() => "");
    throw new Error(`OCR service returned ${response.status}: ${body}`);
  }

  return response.json();
}
